import Header from "../components/Header";
import Accordion from "react-bootstrap/Accordion";
import NavBar from "../components/NavBar";

const FAQ = () => {
  const defaultContent = {
    topic: "Accordion Item #",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  };

  let content = [];
  for (let i = 0; i < 10; i++) {
    content.push(defaultContent);
  }

  return (
    <div className="container-content-fixed">
      <NavBar/>
      <Header title="Frequently Asked Questions" />
      <p>Have any questions? Read popular answers below</p>
      <Accordion defaultActiveKey="0" style={{ margin: "10px 0px" }}>
        {content.map(function (item, idx) {
          return (
            <Accordion.Item eventKey={`${idx}`}>
              <Accordion.Header>
                {item.topic}
                {idx + 1}
              </Accordion.Header>
              <Accordion.Body>{item.content}</Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
};

export default FAQ;
